import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const submitContactForm = createAsyncThunk(
  'contact/submit',
  async (formData, { rejectWithValue }) => {
    try {
      // Simulate API call - replace with real endpoint
      await new Promise((resolve) => setTimeout(resolve, 1500));
      return { success: true, message: 'Thank you! We will get back to you shortly.' };
    } catch (err) {
      return rejectWithValue('Something went wrong. Please try again.');
    }
  }
);

const contactSlice = createSlice({
  name: 'contact',
  initialState: {
    status: 'idle', // 'idle' | 'loading' | 'success' | 'error'
    message: '',
    error: null,
  },
  reducers: {
    resetContact(state) {
      state.status = 'idle';
      state.message = '';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitContactForm.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(submitContactForm.fulfilled, (state, action) => {
        state.status = 'success';
        state.message = action.payload.message;
      })
      .addCase(submitContactForm.rejected, (state, action) => {
        state.status = 'error';
        state.error = action.payload;
      });
  },
});

export const { resetContact } = contactSlice.actions;
export default contactSlice.reducer;
